<template>
<div class="dropdown mb-2" :class="[dropdown && 'activeItem']">
    <div class="dropdown-header" @click="toggleDropdown()">
        {{ title }}
        <img src="@/assets/helpers/circle-chevron-down-solid.svg" alt="" class="dropdown-icon" :class="[dropdown && 'active']">
    </div>
    <transition @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
        <div class="dropdown-wrapper" v-if="dropdown">
            <div id="myTabContentHijo" v-if="component=='Bme'">
                <Bme></Bme>
            </div>
            <div id="myTabContentHijo" v-if="component=='Evolucionmedica'">
                <Emedica></Emedica>
            </div>
            <div id="myTabContentHijo" v-if="component=='Hchospitalizacion'">
                <Hchospitalizacion :datapatients="datapatients" :viewMedico="viewMedico" :Clinicahistory="Clinicahistory"></Hchospitalizacion>
            </div>
            <div id="myTabContentHijo" v-if="component=='Hojagrafica'">
                <Hojagrafica></Hojagrafica>
            </div>
            <div id="myTabContentHijo" v-if="component=='Notadeenfermeria'">
                <Notaenfermeria></Notaenfermeria>
            </div>
            <div id="myTabContentHijo" v-if="component=='Kardex'">
                <Kardex></Kardex>
            </div>
            <div id="myTabContentHijo" v-if="component=='Oxigeno'">
                <Oxigeno></Oxigeno>
            </div>
            <div id="myTabContentHijo" v-if="component=='Mhemodinamico'">
                <Mhemodinamico></Mhemodinamico>
            </div>
            <div id="myTabContentHijo" v-if="component=='Rp'">
                <Rp></Rp>
            </div>
            <div id="myTabContentHijo" v-if="component=='balanceHidrico'">
                <BalanceHidri></BalanceHidri>
            </div>
        </div>
    </transition>

</div>
</template>

<script>
import Bme from '@/components/Hospitalizacion/Hospitalizacion/Historia/Bme.vue';
import Emedica from '@/components/Hospitalizacion/Hospitalizacion/Historia/Emedica.vue';
import Hchospitalizacion from '@/components/Hospitalizacion/Hospitalizacion/Historia/Hchospitalizacion.vue';
import Hojagrafica from '@/components/Hospitalizacion/Hospitalizacion/Historia/Hojagrafica.vue';
import Notaenfermeria from '@/components/Hospitalizacion/Hospitalizacion/Historia/Notaenfermeria.vue'
import Kardex from '@/components/Hospitalizacion/Hospitalizacion/Historia/Kardex.vue'
import Oxigeno from '@/components/Hospitalizacion/Hospitalizacion/Historia/Oxigeno.vue'
import Mhemodinamico from '@/components/Hospitalizacion/Hospitalizacion/Historia/Mhemodinamico.vue'
import Rp from '@/components/Hospitalizacion/Hospitalizacion/Historia/Rp.vue'
import BalanceHidri from '@/components/Hospitalizacion/Hospitalizacion/Historia/Balance.vue'
export default {
    name: 'dropdown-component-hospitalizacion',
    props: {
        title: String,
        component: String,
        viewMedico: Number,
        datapatients: {
            type: Object,
            default: () => ({})
        },
        Clinicahistory:{
          type: Object,
            default: () => ({})
        }
    },
    components: {
        Hchospitalizacion,
        Emedica,
        Rp,
        Hojagrafica,
        Notaenfermeria,
        Kardex,
        Oxigeno,
        Bme,
        Mhemodinamico,
        BalanceHidri
    },
    data: () => ({
        dropdown: false
    }),
    methods: {
        toggleDropdown() {
            this.dropdown = !this.dropdown;
        },
        beforeEnter(el) {
            el.style.height = 0
        },
        enter(el) {
            el.style.height = el.scrollHeight + 'px'
        },
        beforeLeave(el) {
            el.style.height = el.scrollHeight + 'px'
        },
        leave(el) {
            el.style.height = 0
        },
    }
}
</script>
